export function capitalizeFirstLetter(string = '') {
  return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase()
}

export function getInitials(firstName, lastName) {
  if (!firstName || !lastName) {
    return ''
  }

  return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
}

export function getInitialsFromFullName(fullName) {
  if (fullName) {
    return fullName
      .split(' ')
      .map((word) => word.charAt(0))
      .slice(0, 2)
      .join('')
  }
  return ''
}

export function getFirstLetterCapitalized(string) {
  if (string) {
    return string.charAt(0).toUpperCase()
  }
  return ''
}

export function replaceSpaceAndQuotes(inputString) {
  // Replace spaces with underscores
  const stringWithUnderscores = inputString.replace(/ /g, '_')

  // Remove single quotes if they exist
  const stringWithoutQuotes = stringWithUnderscores.replace(/'/g, '')

  return stringWithoutQuotes
}
